module.exports = __webpack_public_path__ + "static/media/zhinengwenda.22f11f61.png";